import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { IconChevronLeft, IconChevronRight } from '../Icon/index';
import { IconButton } from '../IconButton/IconButton';
import { StyledPhotoCarouselNavControls } from './PhotoCarouselNavControls.styles';

/**
 * The "Previous photo" and "Next photo" nav buttons that appear on hover.
 *
 * @related ['IconButton']
 * @since 8.66.0
 */
export var PhotoCarouselNavControls = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var leftButtonProps = _ref.leftButtonProps,
    rightButtonProps = _ref.rightButtonProps;
  return /*#__PURE__*/React.createElement(StyledPhotoCarouselNavControls, {
    ref: forwardedRef
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    "aria-hidden": true,
    as: "span",
    bare: false,
    buttonType: "secondary",
    icon: /*#__PURE__*/React.createElement(IconChevronLeft, null),
    inverse: true,
    title: "Previous photo"
  }, leftButtonProps)), /*#__PURE__*/React.createElement(IconButton, _extends({
    "aria-hidden": true,
    as: "span",
    bare: false,
    buttonType: "secondary",
    icon: /*#__PURE__*/React.createElement(IconChevronRight, null),
    inverse: true,
    title: "Next photo"
  }, rightButtonProps)));
});
PhotoCarouselNavControls.displayName = 'PhotoCarouselNavControls';
PhotoCarouselNavControls.propTypes = {
  /**
   * Props passed by `PhotoCarousel`. Contains `onClick` and `disabled`.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  leftButtonProps: PropTypes.object,
  /**
   * Props passed by `PhotoCarousel`. Contains `onClick` and `disabled`.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  rightButtonProps: PropTypes.object
};